module.exports = __webpack_public_path__ + "img/40_37_023_300.2451ada5.jpg";